<template>
    <div>
       <!-- <breadcrumb :routerList="[{to:'/establish/rebate',title:'合同签订'},{title:'返利合同详情'}]"/>-->
        <Breadtabsheader/>
        <div class="h-piece" style="margin:20px">
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>经销商返利合同详情</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form :model="ht" ref="ht" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="合同名称" class="h-elformWrap-2" prop="contractBaseId">
                                <el-input v-model="ht.contractName" :v="ht.contractName" style="width:3.2rem" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="经销商名称" class="h-elformWrap-2">
                                <el-input v-model="ht.agentName" :v="ht.agentName" style="width:3.2rem" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="销售组织" class="h-elformWrap-2">
                                <el-input v-model="ht.organization"  style="width:3.2rem" readonly>
                                </el-input>
                            </el-form-item>
                            <el-form-item  label="销售区域" class="h-elformWrap-2">
                                <el-input :v="ht.area" v-model="ht.area" style="width:3.2rem" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="渠道" class="h-elformWrap-2" v-if="ht.rebateChainGroup == '传统合计'">
                                <dictname category="fl_sales_region_qudao" style="width:3.2rem" :v="ht.salesRegionCode" readonly/>
                            </el-form-item>
                            <el-form-item label="合同类型" class="h-elformWrap-2">
                                <el-input :v="ht.rebateChainGroup" v-model="ht.rebateChainGroup" style="width:3.2rem" readonly>
                                </el-input>
                            </el-form-item>
                            <br>
                            <el-form-item
                                    prop="year"
                                    label="合同有效期"
                                    class="h-elformWrap-2 fltimeselect">
                                <el-date-picker
										style="width: 3.2rem;"
                                        v-model="ht.year"
                                        type="daterange"
                                        value-format="yyyy-MM-dd"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期" readonly>
                                </el-date-picker>
                            </el-form-item>
                            <br>
                            <el-form-item label="业务归属谈判结果" class="h-elformWrap-2" v-if="ht.businessResult!=null">
                                <el-input v-model="ht.businessResult"  style="width:3.2rem" readonly>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="业务归属谈判结果承接方" class="h-elformWrap-2" v-if="ht.businessResultReceiver!=null">
                                <el-input v-model="ht.businessResultReceiver" style="width:3.2rem" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="库存处理结果" class="h-elformWrap-2" v-if="ht.inventoryResult!=null">
                                <el-input v-model="ht.inventoryResult" style="width:3.2rem" readonly></el-input>
                            </el-form-item>
                            <br>
                            <el-form-item label="库存处理结果承接方" class="h-elformWrap-2" v-if="ht.inventoryResultReceiver!=null">
                                <el-input v-model="ht.inventoryResultReceiver" style="width:3.2rem" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="退出原因" class="h-elformWrap-2" v-if="ht.tuichuYuanyin!=null">
                                <el-input v-model="ht.tuichuYuanyin" style="width:3.2rem" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="附件" class="h-elformWrap-2" v-if="ht.tuichuYuanyin!=null">
                                <brupload
                                        :refid=ht.id
                                        reftype="传统合同退出附件"
                                        :limit="1"
                                        :showtime="false"
                                >
                                </brupload>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="h-table h-mrt30 " style="margin: 20px 20px 0 10px;">
                <div class="h-pieceTitle2 message">
                    <h1 class="h1">目标</h1>
                </div>
                <el-table
                        ref="multipleTable"
                        :data="goalFlList"
                        :default-sort="{prop: 'month', order: 'ascending'}"
                        :border="true"
                        stripe
						:span-method="objectSpanMethod"
                        style="width: 100%">
                    <el-table-column
                            type="index"
                            label="#"
                            width="40">
                    </el-table-column>
                    <el-table-column
                            prop="sales_region_code"
                            :show-overflow-tooltip="true"
                            label="渠道"
                    >
                        <template slot-scope="scope">
                            {{scope.row.salesRegionCode|dictname('fl_sales_region_qudao')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="rebateChainGroup"
                            :show-overflow-tooltip="true"
                            label="链群"
                    >
                        <template slot-scope="scope">
                            {{scope.row.rebateChainGroup|dictname('rebate_chain_group')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="rebateSeries"
                            :show-overflow-tooltip="true"
                            label="返利产品"
							min-width="100"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="year"
                            :show-overflow-tooltip="true"
                            label="年份"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="goal1"
                            label="1月目标"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="goal2"
                            label="2月目标"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="goal3"
                            label="3月目标"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="goal4"
                            label="4月目标"
                            width="110">
                    </el-table-column>

                    <el-table-column
                            prop="goal5"
                            label="5月目标"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="goal6"
                            label="6月目标"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="goal7"
                            label="7月目标"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="goal8"
                            label="8月目标"
                            width="110">
                    </el-table-column>

                    <el-table-column
                            prop="goal9"
                            label="9月目标"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="goal10"
                            label="10月目标"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="goal11"
                            label="11月目标"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="goal12"
                            label="12月目标"
                            width="110">
                    </el-table-column>
                    <!--<el-table-column-->
                            <!--prop="rebateCoefficient"-->
                            <!--:show-overflow-tooltip="true"-->
                            <!--label="返利率(%)"-->
                    <!--&gt;-->

                    <!--</el-table-column>-->
                </el-table>
            </div>
        </div>
		<div class="h-table h-mrt30 " style="margin: 0.2rem 0.2rem 0 0.1rem;">
			<div class="anniu">
			    <el-row>
			        <el-button class="h-btn h-bBtn h-bgblueQ2 " @click="cancelHT">返回</el-button>
			    </el-row>
			</div>
		</div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'

    export default {
        data() {
            return {
                //合同名称
                HTName: [],
                //经销商名称
                AgentName: [],
                //表单
                ht: {
                    //有效期
                    year: [],
                },
                f: {},
                //产品list
                goalFlList: [],
				spanArr:[],
				position:''
            }
        },
        mounted() {
            this.query();
        },
        created() {
            this.query();
        },
        beforeRouteLeave(to,from,next){
            if(to.path=='/establish/contractlist' && from.path == '/establish/agentContract'){
                to.meta.keepAlive = true;
            }else{
                to.meta.keepAlive = false;
            }
            next();
        },

        methods: {
			// getSpanArr() {
			//     this.spanArr = [];
			//     this.goalFlList.forEach((item, index) => {
			//         if (index === 0) {
			//             this.spanArr.push(1);
			//             this.position = 0;
			//         } else {
			//             if (this.goalFlList[index].month === this.goalFlList[index - 1].month) {
			//                 this.spanArr[this.position] += 1;
			//                 this.spanArr.push(0);
			//             } else {
			//                 this.spanArr.push(1);
			//                 this.position = index;
			//             }
			//         }
			//     })
			// },
			// objectSpanMethod({row, column, rowIndex, columnIndex}) {
			//     if (column.label == '月份') {
			//         const _row = this.spanArr[rowIndex];
			//         const _col = _row > 0 ? 1 : 0;
			//         return {
			//             rowspan: _row,
			//             colspan: _col
			//         }
			//     }
			// },
            // sortmonth(row,index){
            //     console.log(row,index)
            // },
            query() {
                this.ht.id = this.$route.query.id;
                ss.fanli.selectTarget(this.ht.id).then(rd => {
                    this.ht = rd;
                    console.log(rd,"11111111111111111")
                    this.getOrgName(rd.contractBaseId);
                    this.goalFlList = rd.goalFlList;
                    this.ht.year=[];
                    this.ht.year.push(rd.contractStartTime);
                    this.ht.year.push(rd.contractEndTime);
                    if(rd.productType=='ct'){
                        this.ht.rebateChainGroup ='传统合计'
                    }else if(rd.productType=='ND4') {
                        this.ht.rebateChainGroup ='疫苗网'
                    }else if(rd.productType=='ND5') {
                        this.ht.rebateChainGroup ='血液网'
                    }else if(rd.productType=='ND9') {
                        this.ht.rebateChainGroup ='试剂网'
                    }
                   // this.ht.rebateChainGroup =rd.productType
					//this.getSpanArr()
                });
            },
            //经销商名称带出其他信息
            showForm(value) {
                this.AgentName.forEach(elements => {
                    this.ht.agentCode = elements.userCode;
                });
            },
            //展示经销商名称
            showFormList(value) {
                this.f.userName = value;
                ss.UserCare.agentOption(this.f).then(rd => {
                    this.AgentName = rd;
                });
            },
            //通过合同名称带出销售组织
            getOrgName(value) {
                this.HTName.forEach(elements => {
                    if (value == elements.id) {
                        this.ht.contractName = elements.contractName;
                        this.ht.orgCode = this.$getDictName('kkber_value', elements.orgCode);
                        console.log("222222222222222222")
                    }
                });
            },
            //展示合同名称
            showHtName() {
                ss.fanli.showHtName().then(rd => {
                    this.HTName = rd;
                })
            },
            //取消提交
            cancelHT() {
                this.$router.push("/establish/contractlist");
            },
        }
    }
</script>
<style scoped>
    .h-tableInput .el-input {
        height: 100%;
    }

    .anniu {
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }

    .DshuR {
        width: 100%;
        height: 100%;
        border: none;
    }

</style>
<style>
    .n-two .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.8rem
    }

    .n-two .h-formbLine .el-form-item__label {
        width: 40%;
    }

    .n-two .h-formbLine .el-form-item__content {
        width: 60%;
    }

    .create .h-formbLine .el-form-item__label {
        width: 31%;
        text-align: right;
    }

    .create .h-formbLine .el-form-item__content {
        width: 69%;
    }

    .fltimeselect .el-date-editor.el-input__inner {
        width: 4rem;
    }

    .fltimeselect .el-form-item__content {
        line-height: 0.2rem;
    }

    .fltimeselect .el-date-editor .el-range-separator {
        width: 12%;
        line-height: 17px;
    }

    .fltimeselect .el-input__inner {
        padding-right: 0.1rem;
    }
</style>
